const clamp = function (value, minValue, maxValue) {
  return Math.max(minValue, Math.min(maxValue, value))
}

const offsetLatLngByMeters = function (lat, lng, meters, bearingDeg) {
  const R = 6378137
  const brng = bearingDeg * (Math.PI / 180)
  const dByR = meters / R
  const lat1 = lat * (Math.PI / 180)
  const lon1 = lng * (Math.PI / 180)

  const lat2 = Math.asin(Math.sin(lat1) * Math.cos(dByR) + Math.cos(lat1) * Math.sin(dByR) * Math.cos(brng))
  const lon2 = lon1 + Math.atan2(
    Math.sin(brng) * Math.sin(dByR) * Math.cos(lat1),
    Math.cos(dByR) - Math.sin(lat1) * Math.sin(lat2)
  )
  return {
    lat: lat2 * (180 / Math.PI),
    lng: lon2 * (180 / Math.PI)
  }
}

const bearingBetweenLatLng = function (lat1, lng1, lat2, lng2) {
  const p1 = lat1 * (Math.PI / 180)
  const p2 = lat2 * (Math.PI / 180)
  const dLon = (lng2 - lng1) * (Math.PI / 180)
  const y = Math.sin(dLon) * Math.cos(p2)
  const x = Math.cos(p1) * Math.sin(p2) - Math.sin(p1) * Math.cos(p2) * Math.cos(dLon)
  const b = Math.atan2(y, x) * (180 / Math.PI)
  return (b + 360) % 360
}

const angleDiffDeg = function (aDeg, bDeg) {
  let diff = Math.abs((aDeg - bDeg) % 360)
  if (diff > 180) diff = 360 - diff
  return diff
}

const axialDiffDeg = function (aDeg, bDeg) {
  let diff = Math.abs((aDeg - bDeg) % 180)
  if (diff > 90) diff = 180 - diff
  return diff
}

const normalizeBearingDeg = function (deg) {
  if (!Number.isFinite(deg)) return NaN
  let out = deg % 360
  if (out < 0) out += 360
  return out
}

const roundToTenth = function (value) {
  return Math.round(value * 10) / 10
}

const toFiniteNumber = function (value) {
  let raw = value
  if (Array.isArray(raw)) raw = raw[0]
  if (raw && typeof raw === 'object' && Object.prototype.hasOwnProperty.call(raw, '_text')) {
    raw = raw._text
  }
  if (raw === null || raw === undefined) return null
  if (typeof raw === 'string' && String(raw).trim() === '') return null
  const parsed = Number(raw)
  return Number.isFinite(parsed) ? parsed : null
}

const interpolateByRatioNullable = function (startVal, endVal, t) {
  const s = toFiniteNumber(startVal)
  const e = toFiniteNumber(endVal)
  const ratio = Number.isFinite(Number(t)) ? Number(t) : 0.5
  const safeRatio = clamp(ratio, 0, 1)
  if (s !== null && e !== null) return s + ((e - s) * safeRatio)
  if (s !== null) return s
  if (e !== null) return e
  return null
}

export {
  clamp,
  offsetLatLngByMeters,
  bearingBetweenLatLng,
  angleDiffDeg,
  axialDiffDeg,
  normalizeBearingDeg,
  roundToTenth,
  toFiniteNumber,
  interpolateByRatioNullable
}
